import { observer } from "mobx-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { HomeAwayScore } from "@gp/models";

export const FullTimeScore = observer(function FullTimeScore(props: {
	fullTimeScore: HomeAwayScore;
}) {
	const { t } = useTranslation();

	return (
		<div className="event__stats__item">
			<div className="event__stats__label">{t("OFFER_HISTORY.FT")}</div>
			<div className="event__stats__result">
				<span>{props.fullTimeScore.home || 0}</span>
				<span> - </span>
				<span>{props.fullTimeScore.away || 0}</span>
			</div>
		</div>
	);
});
